import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SessionComponent } from './session/session.component';

import { AdminComponent } from '../admin/admin.component';
import { SharedComponent } from './shared.component';
import { CreatesessionComponent } from './createsession/createsession.component';

const routes: Routes = [
  { 
    path: '',
    component:SharedComponent,
    children: [
      { path: 'academicselection', component:SessionComponent, pathMatch: 'full'},
      { path: 'createsession', component:CreatesessionComponent, pathMatch: 'full'},
    ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }
